export type LeftSidebarMode = 'full' | 'close' | 'hidden' | 'compact' | 'mobile'

export const defaultCollapseRoutes = [
  '/grants/organization-details',
  '/grants/user-profile',
  '/grants/report/',
  '/dmah/application',
  'grants/grant-application',
  'grants/ActionPlan',
  'grants/reviewer-profile',
  'grants/ExternalReviewSurvey',
  'grants/review-application',
  'internal/Forms',
  'internal/FormEditor',
  'internal/project-schedule',
  'surveys/SurveyTab'
]

const Layout1SettingsChtc = {
  leftSidebar: {
    show: true,
    mode: 'full' as LeftSidebarMode,
    theme: 'white', // View all valid theme colors inside EgretTheme/themeColors.js
    bgOpacity: 0.1, // 0 ~ 1
    bgImgURL: '/assets/images/chtc-half-logo-bg.png',
    bgStyle: {
      backgroundSize: 'auto',
      backgroundPosition: 'left bottom',
      backgroundRepeat: 'no-repeat',
      color: 'rgba(255, 255, 255, 0.7)'
    },
    headerStyle: {}
  },
  topbar: {
    show: true,
    fixed: true,
    theme: 'white' // View all valid theme colors inside EgretTheme/themeColors.js
  },
  secondarySidebar: {
    show: false
  }

}

export default Layout1SettingsChtc

export type Layout1SettingsChtc = typeof Layout1SettingsChtc
